import { LineStyle } from './AbstractSheetLineShape';
import {
  AbstractSheetShape,
  SheetShapeStyleType,
} from 'src/components/viewers/SheetsViewerV2/shapes/abstract/AbstractSheetShape';
import {
  DefaultShapeStyle,
  HoveredShapeStyle,
  SelectedShapeStyle,
} from 'src/components/viewers/SheetsViewerV2/SheetsViewerV2.config';
import { boostColorBrightness } from 'src/utils/color-util';

export type SheetFillStyle = {
  lineWidth: number;
  fillAlpha: number;
  lineColor: string;
  fillColor: string;
  lineStyle: LineStyle;
};
export type SheetFillStyleSet = {
  [key in SheetShapeStyleType]: SheetFillStyle;
};

export abstract class AbstractSheetFilledShape extends AbstractSheetShape {
  protected styleSet: SheetFillStyleSet | null = null;
  protected shapeStyles: Map<Autodesk.Edit2D.Shape, SheetFillStyleSet> =
    new Map();

  protected setStyle(type: SheetShapeStyleType) {
    // eslint-disable-next-line complexity
    this.shapes.forEach((shape) => {
      // Get the style set for this specific shape, or fall back to the default style set
      const shapeStyleSet = this.shapeStyles.get(shape) || this.styleSet;

      switch (type) {
        case SheetShapeStyleType.default:
          shape.style.lineWidth =
            shapeStyleSet?.[SheetShapeStyleType.default]?.lineWidth ??
            DefaultShapeStyle.lineWidth;
          shape.style.fillAlpha =
            shapeStyleSet?.[SheetShapeStyleType.default]?.fillAlpha ??
            DefaultShapeStyle.fillAlpha;
          shape.style.lineColor =
            shapeStyleSet?.[SheetShapeStyleType.default]?.lineColor ??
            DefaultShapeStyle.lineColor;
          shape.style.fillColor =
            shapeStyleSet?.[SheetShapeStyleType.default]?.fillColor ??
            DefaultShapeStyle.fillColor;
          shape.style.lineStyle =
            shapeStyleSet?.[SheetShapeStyleType.default]?.lineStyle ??
            DefaultShapeStyle.lineStyle;
          break;
        case SheetShapeStyleType.hovered: {
          const defaultFillColor =
            shapeStyleSet?.[SheetShapeStyleType.default]?.fillColor ??
            DefaultShapeStyle.fillColor;
          const defaultLineColor =
            shapeStyleSet?.[SheetShapeStyleType.default]?.lineColor ??
            DefaultShapeStyle.lineColor;

          shape.style.lineWidth =
            shapeStyleSet?.[SheetShapeStyleType.hovered]?.lineWidth ??
            HoveredShapeStyle.lineWidth;
          shape.style.fillAlpha =
            shapeStyleSet?.[SheetShapeStyleType.hovered]?.fillAlpha ??
            HoveredShapeStyle.fillAlpha;
          shape.style.lineColor = boostColorBrightness(defaultLineColor);
          shape.style.fillColor = boostColorBrightness(defaultFillColor);
          shape.style.lineStyle =
            shapeStyleSet?.[SheetShapeStyleType.hovered]?.lineStyle ??
            HoveredShapeStyle.lineStyle;
          break;
        }
        case SheetShapeStyleType.selected:
          shape.style.lineWidth =
            shapeStyleSet?.[SheetShapeStyleType.selected]?.lineWidth ??
            SelectedShapeStyle.lineWidth;
          shape.style.fillAlpha =
            shapeStyleSet?.[SheetShapeStyleType.selected]?.fillAlpha ??
            SelectedShapeStyle.fillAlpha;
          shape.style.lineColor =
            shapeStyleSet?.[SheetShapeStyleType.selected]?.lineColor ??
            SelectedShapeStyle.lineColor;
          shape.style.fillColor =
            shapeStyleSet?.[SheetShapeStyleType.selected]?.fillColor ??
            SelectedShapeStyle.fillColor;
          shape.style.lineStyle =
            shapeStyleSet?.[SheetShapeStyleType.selected]?.lineStyle ??
            SelectedShapeStyle.lineStyle;
          break;
      }
    });
  }

  protected setShapeStyle(
    shape: Autodesk.Edit2D.Shape,
    styleSet: SheetFillStyleSet
  ) {
    this.shapeStyles.set(shape, styleSet);
  }
}
